import { connect } from 'react-redux';
import {
  getFilterIdentifierCount,
  getFilterOptions,
  getNumberFuturePtos,
  setFilterDrawerOpen,
} from '../../store/openOrder';

import MobileMenuItems from './MobileMenuItems';

const mapStateToProps = state => ({
  affiliateListDropdown: getFilterOptions(state).affiliateListDropdown,
  filterCount: getFilterIdentifierCount(state),
  locations: getFilterOptions(state).locations,
  numberFuturePtos: getNumberFuturePtos(state),
});

const mapDispatchToProps = {
  setFilterDrawerOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileMenuItems);
